import { MsalService } from '@azure/msal-angular';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';
import { SharedVariable } from './../../../custom-shared/util/shared-variable';
import { MasterClienteCreateUserService } from '@app/features/master/master-cliente/cliente-criar-usuario-stepper/master-cliente-create-user.service';
import { Component, Inject, OnInit, ViewChild } from '@angular/core'
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatHorizontalStepper } from '@angular/material/stepper'
import { ActivatedRoute, Router } from '@angular/router'
import { Client } from '@app/core/models/client.model'
import { User } from '@app/core/models/user.model'
import * as fromStore from '@app/core/store'
import { ConfirmBoxColor } from '@app/custom-shared/components/alerts/confirm-box/confirm-box.component'
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service'
import { PromptBoxColor } from '@app/custom-shared/components/alerts/prompt-box/prompt-box.component'
import { CaceisIcons } from '@app/custom-shared/components/icons/caceis-icon/caceis-icon.component'
import { CaceisMessages } from '@app/custom-shared/consts/caceis-messages'
import { AppScreenUtil } from '@app/custom-shared/util/app-screen-util'
import { UserStatus } from '@app/shared/models/user-status'
import { ScreenComponent } from '@core/features/screen.component'
import * as fromMaster from '@features/master/create-user/store'
import { Language } from '@models/enums/language.enum'
import { Nationality } from '@models/enums/nationality.enum'
import { Store } from '@ngrx/store'
import { UserService } from '@services-api/user.service'
import { FeatureService } from '@services/feature/feature.service'
import { get } from 'lodash'
import { stringify } from 'querystring'
import { BehaviorSubject, Observable } from 'rxjs'
import {
  CreateUserModel,
  GenericId,
  SaveProfileRequest,
} from '../create-user/master-create-user-model'
import { EditUserService } from './edit-user.service'
import { UtilInputForm1 } from './util/util-edit-user'
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { MasterCreateUserService } from '../create-user/master-create-user.service'
import { MasterBoPerfilAcessoComponent } from '@app/features/master-bo-perfil-acesso/master-bo-perfil-acesso.component';

@Component({
  selector: 'app-master-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
})
export class EditUserComponent extends AppScreenBase implements OnInit {
  isVisible: boolean = false;
  isNewSso: boolean = false;
  protected onClose(): void {
  }
  nationalityValues$: Observable<any>
  languageValues$: Observable<any>

  clientList: any[] = []
  clientListDynamic: Array<Client[]> = []
  ddiList = []
  user: User
  statusList = []
  selectedStatus: string
  utilForm1: UtilInputForm1
  caceisIcons = CaceisIcons
  clientes$ = new BehaviorSubject<any[]>([])
  teste: boolean = false
  form: FormGroup
  form2: FormGroup
  @ViewChild('stepper', { static: false }) stepper: MatHorizontalStepper
  val:any
  keys = `userId,,,probgress,Dadospessoais,info,nacionalidade,nationality,lblCpf,cpf,passportnumber,passport,NOME,name,nascimento,birthDate,lblRg,rg,Dadosdecontato,email,login,celular,ddi,fone,ConfigConta,lblClientsPlus,clients.fantasyName,clients,Status,status,idioma,language,userSso`
  errorInternet: string = ''
  @ViewChild(MasterBoPerfilAcessoComponent) masterBoPerfilAcessoComponent!: MasterBoPerfilAcessoComponent;

  /**
   * Default Constructor of the component
   */
  constructor(
    private featureService: FeatureService,
    private userService: UserService,
    public dialogRef: MatDialogRef<EditUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogBoxService: DialogBoxService,
    private repository: EditUserService,
    private msuserservice: MasterCreateUserService,
    private createUserService: MasterClienteCreateUserService,
    private shared: SharedVariable,
    private msalService: MsalService,
    private profileService: ProfileManagerService,

  ) {
    super()
  }
  getClientName(client: any) {
    this.getClientList(0);
    if (!client.institutionCode && this.clientList.filter(it => it.institutionCode && (it.legalName == client.legalName || it.legalName == client.name)).length) {

      client.institutionCode = this.clientList.filter(it => it.institutionCode && (it.legalName == client.legalName || it.legalName == client.name))[0].institutionCode
    }
    if (client) {
      const abbreviation: string = client.institutionCode ? `${client.institutionCode} - ` : "";
      const legalName: string = client.name ? `${client.name} ` : `${client.legalName}`;
      return abbreviation + legalName;
    } else {
      return ""
    }


  }
  getValue(event){
    let val = event.target.value
    if (this.val.userSso != null) {
      if(event.target.value== ""){
        this.form.get('userSso').setValidators([Validators.required]);
        this.form.get('userSso').updateValueAndValidity();
      }else if( /^\s*$/.test(event.target.value)){
        this.form.get('userSso').setValidators([Validators.required,this.emptyFieldValidator(event.target.value)]);
        this.form.get('userSso').updateValueAndValidity();
      }else {
        this.form.get('userSso').clearValidators();
        this.form.get('userSso').updateValueAndValidity();
      }
    }
    return val;
  }
  emptyFieldValidator(val:any){
    return (control: FormControl): { [s: string]: boolean } => {
      if (control.value) {
      if (/\s/g.test(val)) {
    
      return { 'requiredField': true }
    }   
      }
      return null;
  }
}
  ngOnInit() {


    // Criação dos formularios de criar usuario
    this.form = this.createForm()
    this.form2 = this.createForm2()

    this.utilForm1 = new UtilInputForm1(this.form)

    // this.userService.listAllClients().subscribe(resultClientList => {
    //   // console.log('clientList => ', resultClientList);

    //   // Carrega os dados do usuario
    const payload = `{"id": "${this.data.id}"}`
    this.userService.getUserById(payload).subscribe((userJson: User) => {
      // if (userJson.userSso != null) {
      //   this.form.controls['userSso'].disable();
      // }
      // userJson.clients = userJson.clients.map(item => {
      //   let name
      //   if (item.fantasyName && item.fantasyName.trim().length > 0) {
      //     name = item.fantasyName
      //   } else {
      //     name = item.legalName
      //   }
      //   return { name: { name: name, id: item.id, cnpj: item.cnpj } }
      // })

      //     // interseção das listas (clientes e clientes do usuario)
      //     //intersectionListOfClient = resultClientList.filter(value => userJson.clients.includes(value))

      //     // distinção das listas (clientes e clientes do usuario)
      //     const distinctListOfClients = resultClientList
      //       // .concat(userJson.clients.map(item => item.name))
      //       .filter((item, i, arr) => {
      //         return arr.indexOf(arr.find(t => t.id === item.id)) === i
      //       })
      //     this.clientList = distinctListOfClients

      //     this.selectedStatus = userJson.status
      //     // Carrega lista de status
      this.userService.listStatus().subscribe(result => {
        this.statusList = result.map(item => {
          item = this.featureService.translatorService.translateEnumItem(item, 'UserStatus')
          return { label: item, value: item }
        })

        //       // Story #26 - Status novo usuario ou bloqueado
        // if (
        //   this.selectedStatus == UserStatus.novoUsuario ||
        //   this.selectedStatus == UserStatus.bloqueado
        // ) {
        //   this.form.get('status').clearValidators()
        //   this.form.get('reason').clearValidators()
        // }
        this.val=userJson
        this.user = userJson
        console.log("userJSON", this.user)

        this.updateFormValues()

        //   this.onChange()
        // })
      })
    })
  }
/**
   * Sets the focus to the ComboBox component after closing or hiding the possible values list
   * @param element
   * @param value
   */
setComboBoxFocus(element, value) {
  this.featureService.setElementFocus(element, value)
}
  get isUserInactive() {
    return false
  }

  onChange() {
    // this.clientes$.next(this.form.value.clients)
  }

  updateFormValues(): void {
    // if (this.user == null || this.user == undefined) return

    // Carrega os controles de Clientes
    // for (let index = 0; index < this.user.clients.length; index++) {
    // this.addClientsItem()
    // this.clientListDynamic.push(Object.assign([], this.clientList))
    // // }
    // this.form.get('clients').setValue(this.user.clients)
    // this.form.get('client').setValue(this.user.clients[0].name.name)
    this.form.get('id').setValue(this.data.id)
    this.form.get('name').setValue(this.user.name)
    this.form.get('userSso').setValue(this.user.userSso)
    this.form.get('status').setValue(this.user.status)

    if (this.user.nationality)
      this.form.get('nationality').setValue(this.user.nationality.toLowerCase())
    if (this.user.cpf) this.form.get('cpf').setValue(this.user.cpf)
    if (this.user.passport)
      this.form.get('passport').setValue(this.user.passport)
    this.form.get('login').setValue(this.user.login)
    this.form.get('language').setValue(this.user.language)
  }

  /**
   * Initialize the component by the provided data object
   * @param item
   */
  init(item) { }

  validateRadioButton(): void {
    if (this.islblCpfVisible()) {
      this.form.controls['cpf'].markAsTouched({ onlySelf: true })
    }

    if (this.ispassportnumberVisible()) {
      this.form.controls['passport'].markAsTouched({ onlySelf: true })
    }

    if (this.islblRgVisible()) {
      this.form.controls['rg'].markAsTouched({ onlySelf: true })
    }
  }

  /// Valida recursivamente todos os campos do form1(form)
  validateForm1(formGroup: FormGroup | FormArray): boolean {
    let isInvalid = this.form.invalid

    if (isInvalid) {
      this.form.controls['clients'].markAllAsTouched()

      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field)

        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true })
        } else if (control instanceof FormGroup) {
          this.validateForm1(control)
        }
      })
    }
    return !isInvalid
  }


  validateAndGoToStep2() {
    let body = {}
    if (this.form.get('nationality').value == "residente") {
      if (this.form.get('cpf').value) {
        let cpf = this.form.get('cpf').value
            cpf = cpf.replaceAll('.','')
            cpf = cpf.replaceAll('-','')
             body = {
              // "login": this.msalService.instance.getAllAccounts()[0].name,
              "login": this.shared.userSso,
              "name": this.form.get('userSso').value,
              "cpf": cpf,
            }
      }
      const payload = `{"id": "${this.data.id}"}`
              if(this.form.get('userSso').value != null &&  this.form.get('userSso').value!= this.user.userSso) {
                if (this.user.userSso === null || this.user.userSso === '') {
                  this.msuserservice
                    .consultUserSSO(body)
                    .toPromise()
                    .then(res => {
                      if (Number(res.result) < 100) {
                        if (this.user.userSso === null) {
                          this.isNewSso = true
                          this.teste = true
                        } else {
                          this.isNewSso = false
                        }

                        if (this.validateForm1(null)) {
                          this.goToStep(1) // vai para o step 2
                        }
                      } else {
                        setTimeout(() => {
                          this.featureService.translatorService
                            .translateEnumItem(res.messag, 'CaceisMessages')
                            .showError()
                        }, 1500)
                      }
                    })
                } else {
                  this.teste = true
                  if (this.validateForm1(null)) {
                    this.goToStep(1) // vai para o step 2
                  }
                }
        }else {
            this.teste = true;
            if (this.validateForm1(null)) {
            this.goToStep(1); // vai para o step 2
        }
              }
    } else {
      this.teste = true;
      if (this.validateForm1(null)) {
        this.goToStep(1); // vai para o step 2
      }
}



  }

  onSubmit() {
    // console.log({...this.form.value, ...this.form2.value});
    // this.service.postUsingPOST(this.params);
  }

  onSave() {
    let titlepopup, messagePopUp, cancelPopUp, savePopUp, userName, wasSavedMsg,warnPerm: string
    this.featureService.translatorService.getMessage('userName').subscribe(
      data => userName = data
    )
    this.featureService.translatorService.getMessage('wasSaved').subscribe(
      data => wasSavedMsg = data
    )
    this.featureService.translatorService
      .getMessage('titleEditClient')
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('messageEditClient')
      .subscribe(val => {
        messagePopUp = val
      })
    this.featureService.translatorService
      .getMessage('cancelConfirm')
      .subscribe(val => {
        cancelPopUp = val
      })
    this.featureService.translatorService
      .getMessage('saveConfirm')
      .subscribe(val => {
        savePopUp = val
      })
      this.featureService.translatorService.
      getMessage('Selecione ao menos 1 relatório')
      .subscribe(
        data=>warnPerm=data
      )
      let cpf = this.form.get('cpf').value
      if (cpf) {
      cpf = cpf.replaceAll('.','')
      cpf = cpf.replaceAll('-','')
      }
      const isValid = this.masterBoPerfilAcessoComponent.validateCheckedItems();
      if (!isValid) {
        warnPerm.showWarn();
        return;
      }
    this.dialogBoxService.confirmBox({
      lblTitle: titlepopup,
      lblSubtitle: messagePopUp,
      color: ConfirmBoxColor.info,
      lblCancelButton: cancelPopUp,
      lblConfirmButton: savePopUp,
      onConfirm: () => {

        const saveProfilePayload = this.getSaveProfilePayload()
            let body = {
              "cpf": cpf,
              "email": this.form.get('login').value,
              "idioma": this.form.get('language').value ,
              "nomeUsuario": this.form.get('name').value ,
              "perfil": "2",
              "usuario": this.form.get('userSso').value,
              // "ususarioMaster": this.msalService.instance.getAllAccounts()[0].name
              "ususarioMaster": this.shared.userSso
            }
            if (this.form.controls['userSso'].value != null  && this.form.get('nationality').value == "residente") {
                if(this.isNewSso == true) {
                  this.msuserservice.createUserSSO(body, saveProfilePayload).toPromise()
                  .then(res => {
                    if (Number(res.result) < 100) {
                      this.repository
                  .saveProfile(saveProfilePayload)
                  .toPromise().then((result: GenericId) => {
                    const createUserPayload = this.getCreateUserPayload(result[0].id)
                    this.repository.editUser(createUserPayload).subscribe(res => {

                            setTimeout(() => {
                              this.featureService.translatorService
                                .translateEnumItem(
                                  CaceisMessages.SUCCESS_CREATE_USER,
                                  'CaceisMessages'
                                )
                                .showSuccess()
                                this.closeWithoutAsk();
                            }, 1500)
                      })
                  })

                    } else {
                            setTimeout(() => {
                              this.featureService.translatorService
                                .translateEnumItem(
                                  res.messag,
                                  'CaceisMessages'
                                )
                                .showError()
                            }, 1500)
                    }

                  }).catch(err => {
                    setTimeout(() => {
                      this.featureService.translatorService
                        .translateEnumItem(
                          err,
                          'CaceisMessages'
                        )
                        .showError()
                    }, 1500)
                  })
                } else {
                  let userSso = this.form.get('userSso').value
                  this.msuserservice.updateUserSSO(body,userSso,this.shared.userSso).toPromise()
                  .then(res => {
                    this.repository
                    .saveProfile(saveProfilePayload)
                    .toPromise().then((result: GenericId) => {
                      const createUserPayload = this.getCreateUserPayload(result[0].id)
                      this.repository.editUser(createUserPayload).subscribe(res => {

                              setTimeout(() => {
                                // this.featureService.translatorService
                                //   .translateEnumItem(
                                //     CaceisMessages.SUCCESS_CREATE_USER,
                                //     'CaceisMessages'
                                //   )
                                //   .showSuccess()
                                this.dialogBoxService.snackbarUtil.showSuccess(
                                      userName + ` "${body.nomeUsuario}" ` + wasSavedMsg,
                                    );
                                    this.closeWithoutAsk();
                                  }, 1500)
                              // }, 1500)
                        })
                    })

                  })
                }

            } else {
              this.repository
                  .saveProfile(saveProfilePayload)
                  .toPromise().then((result: GenericId) => {
                    const createUserPayload = this.getCreateUserPayload(result[0].id)
                          this.repository.editUser(createUserPayload).subscribe(res => {

                          setTimeout(() => {
                          //   this.featureService.translatorService
                          //     .translateEnumItem(
                          //       CaceisMessages.SUCCESS_CREATE_USER,
                          //       'CaceisMessages'
                          //     )
                          //     .showSuccess()
                          // }, 1500)
                          this.dialogBoxService.snackbarUtil.showSuccess(
                                userName + ` "${body.nomeUsuario}" ` + wasSavedMsg,
                              );
                              this.closeWithoutAsk();
                            }, 1500)
                    })
                  })

            }
            // setTimeout(() => {
            //   this.dialogBoxService.snackbarUtil.showSuccess(
            //     userName + ` "${body.nomeUsuario}" ` + wasSavedMsg,
            //   );
            // }, 1500)
            // this.closeWithoutAsk()
          // })
      },
    })
  }

  getSaveProfilePayload(): any {
    const payload: CreateUserModel = {
      ...this.form.value,
      ...this.form2.value,
    }
    const profile = payload.permissionGroups.profile
    if (this.form.value.cpf != null) {
      payload.cpf = this.form.value.cpf.replace(/\D/g, '')
    }
    const institutionOwner = []

    payload.clients.forEach(item => {
      let client = {
        cnpj: item.name.cnpj,
        id: item.name.id,
        name: item.name.name,
      }
      institutionOwner.push(client)
    })
    const permissionGroupIds = payload.permissionGroups.permissionGroups.map(
      grupo => {
        return grupo.permissions
          .filter(permissao => {
            return permissao.checked == true
          })
          .map(item => {
            return { id: item.id }
          })
      }
    )
    const permissions = [].concat(...permissionGroupIds)

    const saveProfileRequest = {
      profile: profile,
      clients: institutionOwner,
      permissions: permissions,
    }

    return saveProfileRequest
  }

  filterTypeUser(userNacionality, form) {
    const { cpf, passport, ...restForm } = form
    const formByTypeUser = {
      estrangeiro: { ...restForm, passport },
      residente: { ...restForm, cpf },
    }

    return formByTypeUser[userNacionality]
  }

  getCreateUserPayload(id: string) {
    console.log(id)
    const formProps = { ...this.form.value }
    let payload = this.filterTypeUser(formProps['nationality'], formProps)
    if (this.form.value.cpf != null) {
      payload.cpf = this.form.value.cpf.replace(/\D/g, '')
    }
    payload['permissionGroups'] = [{ id: id }]
    return payload
  }

  /// Avança um step da tela
  onNext(): void {
    this.stepper.next()
    AppScreenUtil.scrollAllModalToTop()
  }

  /// Retorna um step da tela
  onPrevious(): void {
    this.stepper.previous()
    AppScreenUtil.scrollAllModalToTop()
  }

  /// Muda para um step específico
  goToStep(index: number): void {
    this.teste = true
    this.stepper.selectedIndex = index
    AppScreenUtil.scrollAllModalToTop()
  }

  getStepOneIcon(): string {
    if (this.stepper == null || this.stepper.selectedIndex == 0)
      return 'icon-step-1'
    if (this.stepper.selectedIndex == 1) return 'icon-step-check'
  }

  getStepTwoIcon(): string {
    if (this.stepper == null || this.stepper.selectedIndex == 0)
      return 'icon-step-2 icon-step-disable '
    if (this.stepper.selectedIndex == 1) return 'icon-step-2'
  }

  getProgressBarValue(): number {
    if (this.stepper == null) return 50

    if (this.stepper.selectedIndex == 0) return 50
    if (this.stepper.selectedIndex == 1) return 100
  }

  /*  getPayload() {
     return {
       ...this.params,
       ...this.ctx,
       code: this.getCode(),
       keys: this.keys,
       parentCtx: { ...this.parentCtx },
     }
   } */

  /* private getCode() {
    return this.parentCtx && this.parentCtx.code
      ? this.parentCtx.code
      : this.getParamCode()
  } */
  /* private getParamCode() {
    const id = this.activeRoute.snapshot.params.id
    return id && !id.startsWith('{') ? id : undefined
  } */

  /*  private getParentCtxParam() {
     const id = this.activeRoute.snapshot.params.id
     return id && id.startsWith('{') ? JSON.parse(id) : this.parentCtx
   } */
  /*
    getScreenCtx() {
      return fromStore.buildScreenCtx(
        'Master',
        'CreateUser',
        this.screenId,
        this.parentCtx ? this.parentCtx.roleName : null,
        this.parentCtx ? this.parentCtx.rootId : null,
        this.parentCtx && this.parentCtx.roleName
          ? this.screenId + ',' + this.parentCtx.screenId
          : null
      )
    } */

  createForm(): FormGroup {
    return this.featureService.formBuilder.group({
      id: [null, []],
      userSso: [null, []],
      nationality: [null, [Validators.required]],
      cpf: [null, [Validators.required]],
      passport: [null, []],
      name: [null, [Validators.required]],
      login: [null, [Validators.required]],
      clients: this.featureService.formBuilder.array([]),
      status: [null, [Validators.required]],
      reason: [null, [Validators.required]],
      language: [null, [Validators.required]],
    })
  }

  createForm2(): FormGroup {
    return this.featureService.formBuilder.group({
      profileId: [null, [Validators.required]],
      permissionGroups: [null, [Validators.required]],
    })
  }

  getNationalityValues(): Observable<any> {
    return (this.nationalityValues$ =
      this.nationalityValues$ ||
      this.featureService.translatorService.enumValues(
        Nationality,
        'Nationality'
      ))
  }

  getLanguageValues(): Observable<any> {
    return (this.languageValues$ =
      this.languageValues$ ||
      this.featureService.translatorService.enumValues(Language, 'Language'))
  }

  getClientsGroup() {
    return this.featureService.formBuilder.group({
      name: [null, [Validators.required]],
    })
  }

  isReasonVisible(): boolean {
    let result =
      this.form.get('status').value != null &&
      this.user.status != this.form.get('status').value &&
      'Inativo' != this.form.get('status').value

    if (result !== true) {
      this.form.get('reason').clearValidators()
      this.form.get('reason').updateValueAndValidity()
    } else {
      this.form.get('reason').setValidators([Validators.required])
      return true

    }
    if (this.form.get('status').value == 'Ativo') {
      return false
    }
  }

  isResidente(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality')
    if (!nationality) return false
    const result = nationality.toString().toLowerCase() != 'estrangeiro'
    return result
  }

  islblCpfVisible(): boolean {
    return this.isResidente()
  }

  iscpfVisible(): boolean {
    const result = this.isResidente()

    if (result !== true) {
      this.form.get('cpf').clearValidators()
      this.form.get('cpf').updateValueAndValidity()
    } else {
      this.form.get('cpf').setValidators([Validators.required])
    }
    return result
  }

  ispassportnumberVisible(): boolean {
    return !this.isResidente()
  }

  ispassportVisible(): boolean {
    const result = !this.isResidente()

    if (result !== true) {
      this.form.get('passport').clearValidators()
      this.form.get('passport').updateValueAndValidity()
    } else {
      this.form.get('passport').setValidators([])
    }
    return result
  }

  islblRgVisible(): boolean {
    return this.isResidente()
  }

  isrgVisible(): boolean {
    const result = this.isResidente()

    if (result !== true) {
      this.form.get('rg').clearValidators()
      this.form.get('rg').updateValueAndValidity()
    } else {
      this.form.get('rg').setValidators([Validators.required])
    }
    return result
  }

  ispassportRequired(): boolean {
    const result = !this.isResidente()

    if (result) {
      this.form.get('passport').setValidators([Validators.required])
    }
    return result
  }

  islanguageReadOnly(): boolean {
    const language =
      get(this.form.value, 'language') || get(this.data, 'language')
    return language == 'português'
  }




  getClientList(index) {
    // this.clientListDynamic = []

    // this.clients.controls.forEach((control, i) => {
    //   let arr = this.getClientListFiltered()

    //   if (
    //     control.value.name != '' &&
    //     control.value.name != null &&
    //     arr.indexOf(control.value.name) < 0
    //   ) {
    //     arr.push(control.value.name)
    //   }
    //   this.clientListDynamic.push(arr)
    // })

    // if (this.clientListDynamic.length == 0) {
    //   this.clientListDynamic.push(this.clientList)
    // }

    // return this.clientListDynamic
  }

  getClientListFiltered() {
    // let selectedClients = this.clients.controls
    //   .filter(control => {
    //     return (
    //       control.value != null &&
    //       control.value.name != '' &&
    //       control.value['name'] != null &&
    //       control.value['name'] != ''
    //     )
    //   })
    //   .map(control => control.value.name)

    // let result: Client[] = []
    // result = this.clientList.filter(function(client) {
    //   let hasItem = false

    //   selectedClients.forEach(seletedClient => {
    //     if (
    //       seletedClient.name != null &&
    //       seletedClient.name != '' &&
    //       seletedClient.name == client.name
    //     ) {
    //       hasItem = true
    //     }
    //   })

    //   return !hasItem
    // })

    // return result
  }

  /**
   * Navigate to an auxiliary router outlet
   * @param {object} props
   */
  /*  navigate(
     feature: string,
     screen: string,
     navigationType: string,
     roleName: string
   ): void {
     this.featureService.navigate(
       feature,
       screen,
       navigationType,
       JSON.stringify({
         ...this.ctx,
         roleName,
         rootId: this.ctx.screenId,
       }),
       this.activeRoute
     )
   } */

  onStatusChange(event): void {
    // event.value =  this.featureService.translatorService.translateEnumItem(event.value,'UserStatus')

    if (this.user.status == event.value) {
      this.selectedStatus = event.value
    }
    if (this.form.get('status').value == 'Ativo' || this.form.get('status').value == 'Active') {
      this.isVisible = true;
    }
    if (this.user.status != event.value) {
      if (event.value.toLowerCase() == 'inativo'.toLowerCase() || event.value.toLowerCase() == 'inactive'.toLowerCase()) {

        let sureMsg, unableToReactivateMsg, disableUserTitle, cancelMsg, desativarMsg, changeReasonMsg: string;
        this.featureService.translatorService.getMessage('DeleteTextConfirm').subscribe(
          data => sureMsg = data
        )
        this.featureService.translatorService.getMessage('unableToReactivate').subscribe(
          data => unableToReactivateMsg = data
        )
        this.featureService.translatorService.getMessage('disableUser').subscribe(
          data => disableUserTitle = data
        )
        this.featureService.translatorService.getMessage('DeleteCancelConfirm').subscribe(
          data => cancelMsg = data
        )
        this.featureService.translatorService.getMessage('desativar').subscribe(
          data => desativarMsg = data
        )
        this.featureService.translatorService.getMessage('changeReason').subscribe(
          data => changeReasonMsg = data
        )
        if (event.value.toLowerCase() == 'inativo'.toLowerCase() || event.value.toLowerCase() == 'inactive'.toLowerCase()) {
          this.dialogBoxService.promptBox({
            lblTitle: disableUserTitle,
            lblSubtitle: unableToReactivateMsg + sureMsg,
            color: PromptBoxColor.error,
            lblCancelButton: cancelMsg,
            lblConfirmButton: desativarMsg,
            isRequired: true,
            placeHolder: changeReasonMsg,
            onCancel: () => {
              this.form.get('status').setValue(this.selectedStatus)
            },
            onConfirm: (reason: string) => {
              this.form
                .get('status')
                .setValue((this.selectedStatus = event.value))
              this.data.result = true
              // block SSO
              if (this.form.get('status').value == "Inativo" && (this.user.userSso != null)) {
                let cpf = this.form.get('cpf').value
                cpf = cpf.replaceAll('.','')
                cpf = cpf.replaceAll('-','')
                this.user.cpf = cpf
                this.msuserservice.blockUserSSO(this.user, this.shared.userSso).subscribe(res => {
                    if(Number(res.result) <100 ) {
                      this.userService
                        .inactivateUser(this.data.id, this.user, reason)
                        .toPromise()
                        .then(result => {
                          this.dialogRef.close()
                        })
                        .catch(error => { })
                    } else if (!res) {
                      this.form.controls['status'].setErrors({'incorrect': true});
                    }
                     else {
                      this.form.get('status').setValue('Ativo')
                      this.user.status = 'Ativo'
                      setTimeout(() => {
                        this.featureService.translatorService
                          .translateEnumItem(
                            res.messag,
                            'CaceisMessages'
                          )
                          .showError()
                      }, 1500)
                    }
                })
              } else {
                this.userService
                        .inactivateUser(this.data.id, this.user, reason)
                        .toPromise()
                        .then(result => {
                          this.dialogRef.close()
                        })
                        .catch(error => { })
              }

            },
          })
        }
      } else {
        let changeStatusMsg, influencePermissionsMsg, cancelMsg, saveMsg: string;
        this.featureService.translatorService.getMessage('changeStatus').subscribe(
          data => changeStatusMsg = data
        )
        this.featureService.translatorService.getMessage('influencePermissions').subscribe(
          data => influencePermissionsMsg = data
        )
        this.featureService.translatorService.getMessage('DeleteCancelConfirm').subscribe(
          data => cancelMsg = data
        )
        this.featureService.translatorService.getMessage('saveConfirm').subscribe(
          data => saveMsg = data
        )
        this.dialogBoxService.confirmBox({
          lblTitle: changeStatusMsg,
          lblSubtitle: influencePermissionsMsg,
          color: ConfirmBoxColor.warn,
          lblCancelButton: cancelMsg,
          lblConfirmButton: saveMsg,
          onCancel: () => {
            this.form.get('status').setValue(this.selectedStatus)
          },
          onConfirm: () => {
            this.form
              .get('status')
              .setValue((this.selectedStatus = event.value))
            // this.isVisible=true;
          },
        })
      }
    }
  }

  closeWithoutAsk() {
    this.dialogRef.close()
    this.dialogRef.updateSize('0px', '0px')
  }

  close() {
    let titlepopup, subtitlepopup, cancelpopup, okpopup: string
    this.featureService.translatorService
      .getMessage('titleConfirm')
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('subtitleConfirm')
      .subscribe(val => {
        subtitlepopup = val
      })
    this.featureService.translatorService
      .getMessage('cancelConfirm')
      .subscribe(val => {
        cancelpopup = val
      })
    this.featureService.translatorService
      .getMessage('okConfirm')
      .subscribe(val => {
        okpopup = val
      })
    this.dialogBoxService
      .confirmBox({
        lblTitle: titlepopup,
        lblSubtitle: subtitlepopup,
        lblCancelButton: cancelpopup,
        lblConfirmButton: okpopup,
        color: ConfirmBoxColor.error,
      })
      .afterClosed()
      .subscribe(result => {
        if (result == true) {
          this.closeWithoutAsk()
        }
      })
  }

  getDateFormat(temporalType: string, datePrecision?: string): string {
    return this.featureService.profileService.getDateFormat(
      temporalType,
      datePrecision
    )
  }

  isMasterBO() {
    return this.profileService.isMasterBO();
  }

  isMasterCliente() {
    return this.profileService.isMasterClient();
  }
  cpfValidate = param => {
    let val = param.replace(/[-.]/gi, '');
    val = val.replaceAll('_','')

    if (val.length === 11) {
     // this.isValidatedBycpfservice = false

      let isCpfExistent: boolean;
      let cpfToString = param
      cpfToString = cpfToString.replaceAll('.','')
      cpfToString = cpfToString.replaceAll('-','')
      let payload = { cpf: cpfToString };
     
      let checkCPFService: Observable<any> = this.createUserService.checkCpf(payload);
      checkCPFService.subscribe(response => {
        isCpfExistent = response.isValidCpf;
        if (isCpfExistent && cpfToString!= this.user.cpf) {
     //     this.isValidatedBycpfservice = false
          this.form.controls['cpf'].setErrors({ invalid: true });
     //     this.customErrorMessage = 'CPF já cadastrado';
          return { invalid: true };
        }
       else if(this.checkCpfValidity(val)){
        this.form.controls['cpf'].setErrors({ invalid: true });
      //  this.customErrorMessage = 'CPF inválido';
        return { invalid: true };
        }
         else {
       //   this.isValidatedBycpfservice = true
          this.form.controls['cpf'].setErrors(null);

        }
      });
    }
    else{
     // this.isValidatedBycpfservice = false
      this.form.controls['cpf'].setErrors({ invalid: true });
     // this.customErrorMessage = 'CPF já cadastrado';
      return { invalid: true };
}

 
  };

  checkCpfValidity(val){
    if (
      val == null ||
      val.length < 11 ||
      val == '00000000000' ||
      val == '11111111111' ||
      val == '22222222222' ||
      val == '33333333333' ||
      val == '44444444444' ||
      val == '55555555555' ||
      val == '66666666666' ||
      val == '77777777777' ||
      val == '88888888888' ||
      val == '99999999999'
    ) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      //this.customErrorMessage = 'CPF inválido';
      return  true ;
    }

    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(val.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(9))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
     // this.customErrorMessage = 'CPF inválido';
      return  true 
    }
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(val.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(10))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
     // this.customErrorMessage = 'CPF inválido';
       true 
    }
    // this.form.controls['cpf'].setErrors(null);
   // this.customErrorMessage = '';
    return  false 
  }
}
